module.exports = "/lucky-balls/video/intro_hr.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_hr.mp4
// module id = 886
// module chunks = 0